import * as React from 'react'

function IconWa(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={43}
      height={44}
      viewBox="0 0 43 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.735 6.41C32.693 2.293 27.318.025 21.59.022 9.79.022.184 9.792.18 21.802A22.024 22.024 0 003.038 32.69L0 43.978l11.35-3.029A21.096 21.096 0 0021.581 43.6h.01s-.002 0 0 0C33.39 43.6 42.995 33.829 43 21.82c.002-5.82-2.223-11.293-6.265-15.41zM21.59 39.922h-.007a17.545 17.545 0 01-9.057-2.523l-.65-.393-6.736 1.797 1.798-6.68-.423-.686a18.288 18.288 0 01-2.72-9.634C3.797 11.822 11.78 3.7 21.597 3.7c4.753.002 9.22 1.887 12.58 5.31 3.36 3.42 5.21 7.97 5.207 12.806-.004 9.983-7.987 18.105-17.795 18.105zm9.761-13.56c-.535-.272-3.165-1.588-3.655-1.77-.491-.181-.847-.272-1.204.273-.356.545-1.382 1.771-1.694 2.134-.312.363-.624.408-1.159.135-.534-.272-2.258-.847-4.302-2.7-1.59-1.444-2.664-3.225-2.976-3.77-.312-.546-.033-.84.234-1.11.24-.245.535-.637.803-.954.268-.318.356-.545.535-.908.178-.363.089-.68-.045-.953-.133-.273-1.203-2.952-1.65-4.041-.434-1.061-.875-.917-1.202-.935a21.202 21.202 0 00-1.026-.018c-.356 0-.936.135-1.427.68-.49.546-1.873 1.862-1.873 4.54 0 2.68 1.917 5.267 2.185 5.63.268.364 3.773 5.86 9.139 8.219 1.276.56 2.273.896 3.05 1.146 1.281.415 2.447.357 3.37.217 1.027-.157 3.164-1.317 3.61-2.588.445-1.271.445-2.362.312-2.588-.134-.229-.49-.366-1.025-.638z"
        fill="#C4C4C4"
      />
    </svg>
  )
}

export default IconWa
